import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import configureStore from './redux/configureStore';
import './index.css';
import NavBar from './NavBar';

const store = configureStore();

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'production') {
  // console.log = () => {}
  // console.error = () => {}
  // console.debug = () => {}
  // CWE-1188: stub all console methods so warn/info/group/trace cannot leak in prod
  const noop = () => {};
  console.log = noop;
  console.error = noop;
  console.debug = noop;
  console.warn = noop;
  console.info = noop;
  console.trace = noop;
  console.dir = noop;
  console.table = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
}

const root = createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <NavBar />
    </BrowserRouter>
  </Provider>
);

